(() => {
  'use strict';
  const wide = window.matchMedia('(min-width: 900px)');
  const root = document.documentElement;
  const run = () => {
    const add = document.querySelector('.cdj--service .cdj-service__content.cdj-iv .cdj-service__booking .cdb-add');
    if (!add || !('IntersectionObserver' in window)) return;
    let seen = false;
    const set = () => root.classList.toggle('cd-cta-seen', wide.matches && seen);
    new IntersectionObserver(list => { seen = list[0].isIntersecting; set(); }, { threshold: 1 }).observe(add);
    if (wide.addEventListener) wide.addEventListener('change', set);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true }); else run();
})();
